import React, { useState, useEffect } from 'react'
import { BasicPage } from "../components/BasicPage";
import Person from "@mui/icons-material/Person";
import { useAuth } from "../hooks/useAuth";
import {
    Box, Grid, Stack, Typography, Button,
    TextField, Alert, Card, CardContent,
    Divider, Paper, useTheme
} from "@mui/material";
import {
    FormContainer, TextFieldElement, PasswordRepeatElement,
    CheckboxElement, PasswordElement
} from 'react-hook-form-mui'

import {

} from "firebase/auth";

import { AcUnitOutlined } from '@mui/icons-material';
import { FadingAlert } from '../components/FormFields';

import { auth, translateFirebaseError } from "../firebase";


export const ProfilePage = () => {
    const { user, change, claims, accountID } = useAuth();
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [message, setMessage] = useState("");
    const theme = useTheme();

    const token = useAuth().token; // funktioniert nur so

    const handleSubmit = async (event) => {

        event.preventDefault();
        const data = new FormData(event.currentTarget);

        console.log(data.get("password"))

        setError("");
        try {
            await change(data.get("password"));
            setMessage("Passwort wurde geändert");
            // navigate("/dashboard/profile", { replace: true });
        } catch (err) {
            console.log("Fehler", err.code);
            setError(translateFirebaseError(err));
        }
    };


    return (
        <BasicPage title="Profil" icon={<Person />}>
            <Box maxWidth="800px" margin="0 auto">
                {message && <Alert severity="success" sx={{ mb: 3 }}>{message}</Alert>}
                {error && <Alert severity="error" sx={{ mb: 3 }}>{error}</Alert>}
                
                <Grid container spacing={3}>
                    {/* Personal Information Card */}
                    <Grid item xs={12} md={6}>
                        <Card elevation={2}>
                            <CardContent>
                                <Typography variant="h6" color="primary" gutterBottom>
                                    Persönliche Informationen
                                </Typography>
                                <Divider sx={{ mb: 2 }} />
                                
                                <Stack spacing={1}>
                                    <Box display="flex">
                                        <Typography variant="subtitle2" sx={{ width: 140 }}>Name:</Typography>
                                        <Typography>{claims?.name}</Typography>
                                    </Box>
                                    <Box display="flex">
                                        <Typography variant="subtitle2" sx={{ width: 140 }}>Email:</Typography>
                                        <Typography>{claims?.email}</Typography>
                                    </Box>
                                    <Box display="flex">
                                        <Typography variant="subtitle2" sx={{ width: 140 }}>Telefon:</Typography>
                                        <Typography>{claims?.phone}</Typography>
                                    </Box>
                                    <Box display="flex">
                                        <Typography variant="subtitle2" sx={{ width: 140 }}>Anrede:</Typography>
                                        <Typography>{claims?.son}</Typography>
                                    </Box>
                                </Stack>
                            </CardContent>
                        </Card>
                    </Grid>

                    {/* Account Information Card */}
                    <Grid item xs={12} md={6}>
                        <Card elevation={2}>
                            <CardContent>
                                <Typography variant="h6" color="primary" gutterBottom>
                                    Account Details
                                </Typography>
                                <Divider sx={{ mb: 2 }} />
                                
                                <Stack spacing={1}>
                                    <Box display="flex">
                                        <Typography variant="subtitle2" sx={{ width: 140 }}>Mandant:</Typography>
                                        <Typography>{claims?.tnt}</Typography>
                                    </Box>
                                    <Box display="flex">
                                        <Typography variant="subtitle2" sx={{ width: 140 }}>Firma:</Typography>
                                        <Typography>{claims?.cny}</Typography>
                                    </Box>
                                    <Box display="flex">
                                        <Typography variant="subtitle2" sx={{ width: 140 }}>Role:</Typography>
                                        <Typography>{claims?.role}</Typography>
                                    </Box>
                                    <Box display="flex">
                                        <Typography variant="subtitle2" sx={{ width: 140 }}>Kunden-Nr.:</Typography>
                                        <Typography>{claims?.aid} {Array.isArray(accountID) && accountID.length > 0 && `(${accountID.join(", ")})`}</Typography>
                                    </Box>
                                    <Box display="flex">
                                        <Typography variant="subtitle2" sx={{ width: 140 }}>EDI:</Typography>
                                        <Typography>{claims?.edi ? "Ja" : "Nein"}</Typography>
                                    </Box>
                                    <Box display="flex">
                                        <Typography variant="subtitle2" sx={{ width: 140 }}>Pflichtfelder:</Typography>
                                        <Typography>{claims?.man ? "Ja" : "Nein"}</Typography>
                                    </Box>
                                </Stack>
                            </CardContent>
                        </Card>
                    </Grid>

                    {/* Account Activity Card */}
                    <Grid item xs={12} md={6}>
                        <Card elevation={2}>
                            <CardContent>
                                <Typography variant="h6" color="primary" gutterBottom>
                                    Account Aktivität
                                </Typography>
                                <Divider sx={{ mb: 2 }} />
                                
                                <Stack spacing={1}>
                                    <Box display="flex">
                                        <Typography variant="subtitle2" sx={{ width: 140 }}>Erstellt am:</Typography>
                                        <Typography>
                                            {new Date(user?.metadata?.creationTime).toLocaleDateString('de-DE', { 
                                                day: '2-digit', 
                                                month: '2-digit', 
                                                year: 'numeric' 
                                            })} um {new Date(user?.metadata?.creationTime).toLocaleTimeString('de-DE')}
                                        </Typography>
                                    </Box>
                                    <Box display="flex">
                                        <Typography variant="subtitle2" sx={{ width: 140 }}>Letzte Anmeldung:</Typography>
                                        <Typography>
                                            {new Date(user?.metadata?.lastSignInTime).toLocaleDateString('de-DE', { 
                                                day: '2-digit', 
                                                month: '2-digit', 
                                                year: 'numeric' 
                                            })} um {new Date(user?.metadata?.lastSignInTime).toLocaleTimeString('de-DE')}
                                        </Typography>
                                    </Box>
                                </Stack>
                            </CardContent>
                        </Card>
                    </Grid>

                    {/* Password Change Card */}
                    <Grid item xs={12} md={6}>
                        <Card elevation={2}>
                            <CardContent>
                                <Typography variant="h6" color="primary" gutterBottom>
                                    Passwort ändern
                                </Typography>
                                <Divider sx={{ mb: 2 }} />

                                <Box component="form" onSubmit={handleSubmit} noValidate>
                                    <TextField
                                        required
                                        fullWidth
                                        name="password"
                                        label="Neues Passwort"
                                        type="password"
                                        id="password"
                                        autoComplete="new-password"
                                        sx={{ mb: 2 }}
                                    />
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        fullWidth
                                    >
                                        Passwort ändern
                                    </Button>
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </Box>
        </BasicPage>
    );
};


